const ICONS = {
	alert: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-exclamation-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M12 9v4" /><path d="M12 16v.01" /></svg>',
	clipboard: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-copy"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666" /><path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" /></svg>',
	checkmark: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-square-rounded-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 12l2 2l4 -4" /><path d="M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9" /></svg>',
	info: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-info-square-rounded"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 9h.01" /><path d="M11 12h1v4h1" /><path d="M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9" /></svg>',
	share: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-share-3"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7" /></svg>',
	download: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-download"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>',
	external: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-external-link"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" /><path d="M11 13l9 -9" /><path d="M15 4h5v5" /></svg>'
};

const MODE_DEFAULT_ICONS = {
	info: 'info',
	success: 'checkmark',
	warning: 'alert',
	error: 'alert'
};

const timeout = 4; // Default duration in seconds
const MODES = new Set(['info', 'success', 'warning', 'error']);
let toastId = 0;

function getContainer() {
	let container = document.querySelector('[data-ecko-toast-container]');

	if (!container) {
		container = document.createElement('div');
		container.className = 'ecko-toast-container';
		container.setAttribute('data-ecko-toast-container', '');
		document.body.appendChild(container);
	}

	return container;
}

function removeToast(toast) {
	if (!toast || toast.dataset.removing === 'true') return;

	toast.dataset.removing = 'true';
	toast.classList.add('is-leaving');

	window.setTimeout(() => {
		toast.remove();
	}, 180);
}

export function showToast(options = {}) {
	const config = typeof options === 'string' ? { message: options } : options;
	const message = String(config.message || '').trim();

	if (!message) return null;

	const mode = MODES.has(config.mode) ? config.mode : 'info';
	const iconName = ICONS[config.icon] ? config.icon : MODE_DEFAULT_ICONS[mode];
	const duration = Number.isFinite(config.duration) ? config.duration : timeout * 1000;
	const container = getContainer();
	const toast = document.createElement('div');
	const messageEl = document.createElement('span');
	const iconEl = document.createElement('span');
	const id = `ecko-toast-${++toastId}`;

	toast.className = `ecko-toast ecko-toast--${mode}`;
	toast.id = id;
	toast.setAttribute('role', mode === 'error' ? 'alert' : 'status');
	toast.setAttribute('aria-live', mode === 'error' ? 'assertive' : 'polite');
	toast.setAttribute('data-mode', mode);

	iconEl.className = 'ecko-toast__icon';
	iconEl.innerHTML = ICONS[iconName];
	messageEl.className = 'ecko-toast__message';
	messageEl.textContent = message;

	toast.append(iconEl, messageEl);
	container.appendChild(toast);

	window.requestAnimationFrame(() => {
		toast.classList.add('is-visible');
	});

	if (duration > 0) {
		window.setTimeout(() => removeToast(toast), duration);
	}

	return {
		id,
		element: toast,
		dismiss: () => removeToast(toast)
	};
}

export function initToast() {
	window.eckoToast = window.eckoToast || {};
	window.eckoToast.show = showToast;
}